/* eslint-disable angular/ng_angularelement */
import modalConfirmation from '../../shared/components/modal-response/modal-response.view.html';

let inject = [
    '$scope',
    'CategoryService',
    '$state',
    '$rootScope',
    'SharedService',
    '$stateParams',
    '$uibModal',
    'ProductNotFoundService',
    '$timeout',
    '$mdToast',
    'CatalogService',
    'CartService'
];

class ProductNotFoundController {
    constructor($scope,
                CategoryService,
                $state,
                $rootScope,
                SharedService,
                $stateParams,
                $uibModal,
                ProductNotFoundService,
                $timeout,
                $mdToast,
                CatalogService,
                CartService) {
        this.$state = $state;
        this.$scope = $scope;
        this.CatalogService = CatalogService;
        this.ProductNotFoundService = ProductNotFoundService;
        this.$stateParams = $stateParams;
        this.$rootScope = $rootScope;
        this.$uibModal = $uibModal;
        this.$mdToast = $mdToast;
        this.CartService = CartService;
        this.CategoryService = CategoryService;
        this.SharedService = SharedService;
        this.$timeout = $timeout;
        this.productSearchText = decodeURIComponent(this.$stateParams.productSearchText);
        this.productNotFoundDataForm = {};
        this.mailSent = false;
        this.sending=false;
        this.showCaptchaError = false;
    }

    sendMailProductNotFound() {

        this.sending=true;
        this.productNotFoundDataForm.productSearchText = this.productSearchText;
        if (this.productNotFoundForm.$valid && this.enteredCaptchaContact) {

            this.ProductNotFoundService.mailProductNotFound(this.productNotFoundDataForm).then(response => {
                if (!response.error) {

                  this.productNotFoundDataForm = {};
                  this.productNotFoundForm.$setUntouched();
                  this.productNotFoundForm.$setPristine();
                  this.sending=false;
                  if (__env.adaptative){
                      var mdToast=this.$mdToast;
                      this.$mdToast.show({
                        hideDelay   : 7000,
                        controller  : function () {
                          this.closeToast = function(){
                            mdToast.hide();
                          }

                        },
                        controllerAs:'toast',
                        template : '<md-toast>' +
                        '   <span class="md-toast-text p5" flex> Su mensaje ha sido enviado exitosamente. Pronto uno de nuestros representantes comerciales ' +
                        '   se contactará con usted.' +
                        '</span>' +
                        '  <md-button ng-click="toast.closeToast()">' +
                        '    Cerrar' +
                        '  </md-button>' +
                        '</md-toast>'
                      });

                  }else{
                    this.mailSent = true;
                  }
                }
                else {
                    alert(response.message);
                }
            }).catch(reason => {
                alert('Ha ocurrido un error al enviar el mensaje');
            });
        }
        else {
            this.showCaptchaError = true;
            var validations=[];
            for (var prop in this.productNotFoundForm.$error) {
                if(prop!='undefinded'){
                    angular.forEach(this.productNotFoundForm.$error[prop], function (field) {
                        if(field && field.$$attr.mvalid){
                            validations.push( '<li>' + field.$$attr.mvalid + '</li>') ;
                        }
                    });
                }

            }

            if(!this.enteredCaptchaContact){
              validations.push( '<li> Resolver el captcha</li>' );
            }
            var b = validations.reduce(function(p,c,i,validations){
                if (p.indexOf(c) == -1) p.push(c);
                else p.push('')
                return p;
            }, [])
          let options = {
            title: 'Faltan algunos datos por diligenciar...',
            isHtml: true,
            content: `
                    <div>
                      <p>
                        Para continuar con este proceso debes diligenciar los siguientes datos:
                      </p>
                      <ul style="margin-top: 10px;list-style: inherit;margin-left: 30px;">
                        ${b.join("")}
                      </ul>
                    </div>
                  `,
            size: '',
            showBottonCancel: false,
            textActionCancel: '',
            textAction: 'Aceptar'
          };
          this.messageResponse(options, "active");
            this.sending=false;


        }


    };

    messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
        let modalInstance = this.$uibModal.open({
            animation: true,
            template: modalConfirmation,
            controller: 'ModalResponseController',
            controllerAs: 'mdCtrl',
            size: options.size,
            resolve: {
                modalOptions: () => options
            }
        });
        modalInstance.result.then(() => {
            if (callAcept) {
                callback();
            }
        }).catch(reason => {
            if (callCancel) {
                callbackCancel();
            }
        });
    }
}

ProductNotFoundController.$inject = inject;

export default ProductNotFoundController;




/** WEBPACK FOOTER **
 ** ./www/components/catalog/product-not-found/product-not-found.controller.js
 **/